export const AppRoutes = {
    DeleteAccount: () : string => '/',
    PrivacyPolicy: () : string => '/privacy-policy',
    TermsAndConditions: () : string => '/terms-and-conditions',
    GuestEvent: () : string => '/guest-event',
} as const;
